export default __webpack_public_path__ + "static/media/poster-mockup-inside-of-the-bus-stop-2021-09-04-14-37-18-utc.8a4d7266.png";